export enum PnlCategoriesEnum {
  producing = "producing",
  planned = "planned",
  unplanned = "unplanned",
  waiting = "waiting",
  unknown = "unknown",
  notScheduled = "notScheduled",
  uncollected = "uncollected",
}

export enum PnlCategoryLabelsEnum {
  producing = "Producing",
  planned = "Planned",
  unplanned = "Unplanned",
  waiting = "Waiting",
  unknown = "Unknown",
  notScheduled = "Not Scheduled",
  uncollected = "Uncollected",
  quality = "Quality",
}

export enum PnlCategoriesEnumWithOptionalCategories {
  producing = "producing",
  planned = "planned",
  unplanned = "unplanned",
  waiting = "waiting",
  unknown = "unknown",
  notScheduled = "notScheduled",
  uncollected = "uncollected",
  producingLoss = "producingLoss",
  quality = "quality",
}

export enum TrendChartBinSizesEnum {
  hours = "hours",
  shifts = "shifts",
  days = "days",
  weeks = "weeks",
}

/** internal names for each page */
export enum PageNameEnum {
  customerTiles = "customerTiles",
  processTiles = "processTiles",
  groupTiles = "groupTiles",
  gridLayout = "gridLayout",
  operator = "operator",
  timeline = "timeline",
  trends = "trends",
  hublet = "hublet",
  settings = "settings",
  help = "help",
  reports = "reports",
  schedules = "schedules",
  /** AKA "sight-analytics" */
  powerbi = "powerbi",
  unknown = "unknown",
}

export enum TrendsRangeEnum {
  day = "day",
  week = "week",
  month = "month",
  ninetyDays = "ninetyDays",
  custom = "custom",
}

export enum BreakpointKeysEnum {
  lg = "lg",
  md = "md",
  sm = "sm",
  xs = "xs",
  xxs = "xxs",
}

/** PnlChartColumns to show in addition to the defaults,
 * configured in [LD flag flight-extra-pnl-chart-columns](https://app.launchdarkly.com/default/production/features/flight-extra-pnl-chart-columns/targeting)
 */
export enum ExtraPnlColumnsEnum {
  outputLoss = "outputLoss",
  averageDurationMs = "averageDurationMs",
  numberOfEvents = "numberOfEvents",
}

export enum ReportTypesEnum {
  /** covers EOS, 24-hour, or Weekly reports */
  standardEos = "standardEos",
  /** any other reports */
  custom = "custom",
}
